import React from 'react';

import styled from '@emotion/styled';
import { Trans } from '@lingui/macro';

import CoreLayout from '@zego/layouts/CoreLayout';
import { getColWidthCalc, infoColor, unit, white } from '@zego/theme';
import { pathWithCountry } from '@zego/utils/route';

import ContainerSection from '@zego/components/atoms/ContainerSection';
import H2 from '@zego/components/atoms/H2';
import RegularText from '@zego/components/atoms/RegularText';
import Spacer from '@zego/components/atoms/Spacer';
import View from '@zego/components/atoms/View';
import ContentContainer from '@zego/components/ContentContainer';
import Logo from '@zego/components/header/Logo';
import HomepageHeroBackground from '@zego/components/HomepageHero/HomepageHeroBackground';
import Link from '@zego/components/Link';

const OuterContainer = styled(View)({
  position: 'relative',
  height: '100vh',
});

const BackgroundContainer = styled(View)({
  position: 'absolute',
  top: 0,
  right: 0,
  left: 0,
  bottom: 0,
});

const StyledContentContainer = styled(ContentContainer)({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
});

interface ComingSoonProps {
  country: string;
  emailAddress: string;
  telephoneNumber: string;
}

export default function ComingSoon({
  country,
  emailAddress,
  telephoneNumber,
}: ComingSoonProps): JSX.Element {
  return (
    <CoreLayout>
      <OuterContainer>
        <BackgroundContainer>
          <HomepageHeroBackground />
        </BackgroundContainer>
        <ContainerSection>
          <StyledContentContainer>
            <Link
              href={pathWithCountry(country, '/')}
              css={{
                flexGrow: 0,
                display: 'flex',
                paddingTop: unit(4),
                paddingBottom: unit(4),
                width: unit(4) * 2 + 100,
                fill: white,
              }}
            >
              <Logo />
            </Link>
            <View
              css={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                flex: 1,
                paddingBottom: unit(24),
              }}
            >
              <View
                css={{
                  maxWidth: getColWidthCalc(12, 8, 20),
                }}
              >
                <H2 css={{ color: white }}>
                  <Trans id="Coming Soon / Heading">Coming soon...</Trans>
                </H2>
                <Spacer height={unit(6)} />
                <RegularText>
                  <Trans id="Coming Soon / If you need to get in touch please call">
                    If you need to get in touch please call
                  </Trans>{' '}
                  <br />
                  <Link
                    css={{ color: infoColor(5), textDecoration: 'none' }}
                    href={`tel:${telephoneNumber}`}
                  >
                    {telephoneNumber}
                  </Link>{' '}
                  <Trans id="Coming Soon / or email">or email</Trans>{' '}
                  <Link
                    css={{ color: infoColor(5), textDecoration: 'none' }}
                    href={`mailto:${emailAddress}`}
                  >
                    {emailAddress}
                  </Link>
                </RegularText>
              </View>
            </View>
          </StyledContentContainer>
        </ContainerSection>
      </OuterContainer>
    </CoreLayout>
  );
}
